module.exports = __webpack_public_path__ + "img/UZ.ef2cba68.svg";